import React, {useLayoutEffect, useRef, useState} from 'react';
import AppText from "./AppText";
import {t} from "../../services/i18n";
import {HStack} from "native-base";
import InfoTooltip from "./InfoTooltip";
import CustomTaskDoneCheckbox from "./CustomTaskDoneCheckbox";
import {Colors} from "../../styles/Colors";

const CheckboxTable = (props) => {
    const {columns, rows, infoTooltip, isDisabled, isChecked, onChange, mainColumnName } = props;

    const columnCount = columns?.length || 0;
    const [firstColPx, setFirstColPx] = useState(0);
    const labelRefs = useRef([]);

    useLayoutEffect(() => {
        const maxWidth = Math.max(...labelRefs.current.map(el => el?.offsetWidth || 0));
        if (maxWidth && Math.abs(firstColPx - maxWidth) > 1) setFirstColPx(Math.ceil(maxWidth) + 8);
    }, [rows, columns]);

    const gridColumns = `${firstColPx ? firstColPx + 'px' : 'max-content'} repeat(${columnCount}, 1fr)`;
    const gridGap = '1rem';

    const getChildUncheckedTooltipKey = (row, column) => {
        if (column === 'child' && !isChecked(row, column) && isDisabled(row, column)) {
            return t(`disabled-child-users-boxes-owner-id-tooltip`);
        }
        return t(`disabled-${column}-${row.replaceAll('_', '-')}-tooltip`);
    }

    return (
        <div>
            <div style={{
                paddingBlock: '0.5rem',
                borderBottom: '1px solid #e0e0e0',
                display: 'grid',
                gridTemplateColumns: gridColumns,
                columnGap: gridGap,
                alignItems: 'center'
            }}>
                <div ref={el => (labelRefs.current[0] = el)}>
                    <AppText boldFont>{mainColumnName}</AppText>
                </div>
                {columns?.map(column => (
                    <div style={{textAlign: 'center'}} key={column}>
                        <HStack justifyContent={'center'}>
                            <AppText boldFont>{t(`${column}-flow`)}</AppText>
                            {infoTooltip && infoTooltip[column] && <InfoTooltip title={infoTooltip[column]}/>}
                        </HStack>
                    </div>
                ))}
            </div>
            {rows?.map(row => (
                <div style={{paddingBlock: '1rem', borderBottom: '1px solid #e0e0e0', display: 'grid', gridTemplateColumns: gridColumns, columnGap: gridGap, alignItems: 'center'}} key={row}>
                    <div ref={el => (labelRefs.current[(labelRefs.current?.length || 0)] = el)}>
                        <AppText>{t(`${row.replaceAll('_', '-')}`)}</AppText>
                    </div>
                    {columns?.map(column => (
                        <div style={{display: 'flex', justifyContent: 'center'}} key={column}>
                                <CustomTaskDoneCheckbox
                                    onClick={() => {}}
                                    checkedTooltip={isDisabled(row, column) ? t(`disabled-${column}-${row.replaceAll('_', '-')}-tooltip`)  : ''}
                                    uncheckedTooltip={isDisabled(row, column) ? getChildUncheckedTooltipKey(row, column) : ''}
                                    colors={{primary: Colors.newDesign.mainBlue, primaryBorder: '#E0E0E0', primaryHover: Colors.newDesign.mainBlueHover}}
                                    disabled={isDisabled(row, column)}
                                    checked={isChecked(row, column)}
                                    onChange={(e) => onChange(row, column, e.target.checked)}
                                />
                        </div>
                    ))}
                </div>
            ))}

        </div>
    );
};

export default CheckboxTable;